import React from 'react';
import { Divider, Menu, Dropdown, Avatar } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { user } from 'api';
import Utils from 'utils';
import { toast } from 'react-toast';
import { setLoading } from 'redux/actions/Loader';
import { useDispatch, useSelector } from 'react-redux';
import {
  UserOutlined,
} from '@ant-design/icons';
import { faAddressCard, faInbox, faRulerTriangle, faScrewdriverWrench, faFileInvoiceDollar, faCreditCard, faGrid2Plus, faBullhorn, faShareNodes, faLifeRing, faArrowRightFromBracket, faCommentLines, faGear } from '@fortawesome/pro-light-svg-icons'
import FAIcon from 'components/util-components/FAIcon';
 
import { saveAccount } from 'redux/actions/Account';
import { saveUser, saveUserAccounts, saveUserProfile } from 'redux/actions/User';
const { SubMenu } = Menu;

const menuItem = [
  {
    key: 'account-and-billing',
    title: 'Account and Billing',
    path: '/account-and-billing/overview',
    icon: faCreditCard
  },
  {
    key: 'settings',
    title: 'Settings',
    path: '/settings/account',
    icon: faGear
  },
  /*
  {
    key: 'integrations',
    title: 'Integrations',
    path: '/',
    icon: faGrid2Plus
  },
  {
    key: 'product-updates',
    title: 'Product Updates',
    path: '/',
    icon: faBullhorn
  }, 
  {
    key: 'help-center',
    title: 'Help Center',
    path: '/',
    icon: faLifeRing
  },
  {
    key: 'feedback',
    title: 'Feedback?',
    path: '/',
    icon: faCommentLines
  },
  {
    key: 'refer-a-friend',
    title: 'Refer a Friend',
    path: '/',
    icon: faShareNodes
  }
  */
]

export const NavProfile = () => {

  const history = useHistory();
  const currentUser = useSelector(s => s.user?.details);
  const dispatch = useDispatch();
  const logout = async () => {
    dispatch(setLoading({
      loading: true,
      cover: 'overlay'
    }))
    const response = await auth.logout(); 
    toast.info(response.notice, {
      color: '#fff'
    });
    Utils.removeSessionToken();
    dispatch(saveUser({}))
    dispatch(saveAccount({}))
    dispatch(saveUserProfile({}))
    dispatch(saveUserAccounts([]))
    history.push('/login');
    dispatch(setLoading({
      loading: false
    }))
  }

  const userName = `${currentUser?.first_name} ${currentUser?.last_name}`;
  const profileMenu = (
    <div className="nav-profile nav-dropdown" style={{ width: 290 }}>
      <div className="nav-profile-header">
        <div className="app-userpreferences">
          <Link to="/settings/user-preferences/profile">
            {currentUser?.profile_image ?
              <Avatar size={48} src={currentUser?.profile_image} className="app-nav-avatar" />
              :
              <Avatar size={48} className="app-nav-avatar"><UserOutlined /></Avatar>
            }
            <div className="app-user-info">
              <div className="app-user-info-name">{userName}</div>
              <div className="app-user-info-email">{currentUser?.email}</div>
              <div className="app-user-info-preferences">Profile &amp; Preferences</div>
            </div>
          </Link>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu className="app-userpreferences-menu">
          {menuItem.map((el, i) => {

            return (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <FAIcon icon={el.icon} className='anticon' />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          {/*
          <SubMenu title={<span>
            <img style={{ width: '17px' }} src={'https://logopond.com/logos/d5980f6bf1cc10fd6ff22363cc8a697a.png'} alt={'ys'} className={'anticon'} />
            <span className="font-weight-normal">PushPulse</span>
          </span>}>
            <Menu.Item>
              <span>
                <span className="font-weight-normal app-user-view-accounts">View all accounts</span>
              </span>
            </Menu.Item>
            <Divider style={{ margin: '8px 0' }} />
            <Menu.Item>Account Name 1</Menu.Item>
            <Menu.Item>Account Name 2</Menu.Item>
          </SubMenu>
          */}
          <Menu.Item key={menuItem.length + 1} onClick={logout}>
            <span>
              <FAIcon icon={faArrowRightFromBracket} className='anticon' />
              <span className="font-weight-normal" >Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={['click']}>
      <Menu className="d-flex align-item-center" mode="horizontal" >
        <Menu.Item key="profile" className="app-header-top-nav-menu-item">
          {currentUser?.profile_image ?
            <Avatar src={currentUser?.profile_image} />
            :
            <Avatar ><UserOutlined /></Avatar>
          }
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

//export default NavProfile
export default (NavProfile);